// unitSquareGridPoints( Number, Number )
// returns an array of arrays representing the unit square
// with the given density in each dimension.
// Columns and rows are the number of points.
// Points are edges.
// So if you're using this to define the steps,
// or spaces *between* points, use one more than you need.
// e.g.
// unitSquareGridPoints(3)
// [
//   [
//		[0, 0],   [0.5, 0],   [1, 0]
//	 ],
//   [
//   	[0, 0.5], [0.5, 0.5], [1, 0.5]
// 	 ],
//	 [
//   	[0, 1],   [0.5, 1],   [1, 1]
//	 ]
// ]

export default function unitSquareGridPoints( columns, rows ) {
	if ( rows === undefined ) { // allow squares with one param
		rows = columns;
	}
	return new Array( columns ).fill(0).map( (_, y) =>
		new Array( rows ).fill(0).map( (__, x) => 
			[ x / ( columns - 1 ), y / ( rows - 1 ) ]
		)
	);
 }
 
 